<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import { Span, currency, integer, percentage } from '@smatch/cassiopeia-web-components';

    /* TYPES ----------------------------------------------------------------------------------- */

    import type { Auction } from 'src/app/types';

    /* EXPORTS --------------------------------------------------------------------------------- */

    export let auction: Auction;
    export let config: Record<string, boolean> = {};

    /* INTERNALS ------------------------------------------------------------------------------- */

    $: averagePrice = auction.total.price.retail.recommended / auction.total.quantity.items;
    $: offerPrice = auction.offer.average.perItem;

</script>

    <div class = 's8-fixed s8-header'>
        <span>Name</span>
    </div>
    {#if config.hasColor}
        <div class = 's8-color s8-header'>Color</div>
    {/if}
    {#if config.hasCategory}
        <div class = 's8-category s8-header'>Category</div>
    {/if}
    {#if config.hasGender}
        <div class = 's8-gender s8-header'>Gender</div>
    {/if}
    {#if config.hasSeason}
        <div class = 's8-season s8-header'>Season</div>
    {/if}
    {#if config.hasBrand}
        <div class = 's8-brand s8-header'>Brand</div>
    {/if}
    <div class = 's8-count s8-header !text-right'>
        <Span css = '!block w-full whitespace-nowrap'>
            Total Count
        </Span>
        <Span css = '!block w-full text-xxs font-normal'>
            { integer(auction.total.quantity.items, false) }
            <span class = 'text-grey-600'>Items</span>
        </Span>
    </div>
    <div class = 's8-count s8-header !text-right'>
        <Span css = '!block w-full whitespace-nowrap'>
            Retail Price
        </Span>
        <Span css = '!block w-full text-xxs font-normal'>
            { currency(averagePrice, auction.locale.currencyCode) }
            <span class = 'text-grey-600 whitespace-nowrap'>/ Item</span>
        </Span>
    </div>
    <div class = 's8-count s8-header !text-right'>
        <Span css = '!block w-full whitespace-nowrap'>
            Offer price
        </Span>
        <Span css = '!block w-full text-xxs font-normal'>
            { currency(offerPrice, auction.locale.currencyCode) }
            <span class = 'text-grey-600 whitespace-nowrap'>/ Item</span>
        </Span>
    </div>
    <div class = 's8-count s8-header !text-right'>
        <Span css = '!block w-full whitespace-nowrap'>
            Discount
        </Span>
        {#if auction.discount > 0}
            <Span css = '!block w-full text-xxs font-normal'>
                { percentage(auction.discount) }
                <span class = 'text-grey-600 whitespace-nowrap'>/ Item</span>
            </Span>
        {/if}
    </div>
    <div class = 's8-distribution s8-header'>Distribution</div>
    <div class = 's8-variant s8-header'>Sizes / Colours</div>

<style lang='postcss'>

    div.s8-header {
        @apply border-b border-r border-grey-200 items-center text-center bg-grey-100;
        @apply h-12 px-4 flex flex-col font-semibold justify-center;

        &.s8-fixed {
            @apply sticky left-0 z-10 border-r-0 text-left pl-2 pr-3 border-l border-grey-200;

            &:after{
                @apply absolute left-full top-0 bottom-0 w-2 opacity-10;
                background: linear-gradient(90deg, rgba(39, 39, 17, 1) 0%, rgba(39, 39, 17, 0) 100%);
                content: '';
            }
        }

        &.s8-variant {
            grid-column-start: dimensions-start;
            grid-column-end: dimensions-end;
        }
    }

</style>